import { gql } from "@apollo/client";

const CUSTOM_FIELDS = gql`
  fragment CustomFields on Attribute {
      id
      parent
      title
      type
      enums
      reading
  }
`;

export const CORE_PROJECT_FIELDS = gql`
  ${CUSTOM_FIELDS}
  fragment CoreProjectFields on MdmProjectDTO {
    companyReference
    id
    title
    timezone
    datasetMode
    filterInfo {
      allFields {
        containerType
        fieldType
        key
        label
        inputType
        leaf
        enum {
          key
          label
        }
      }
      allOperators {
        key
        label
      }
    }
    deviceConfigs {
      id
      title
      vitalityThreshold
      measurementMappings {
        key
        value
      }
    }
    configuration {
      analyticsConfiguration {
        dataTypes {
          name
        }
        resultTypes {
          type
        }
      }
      objectConfiguration {
        customFields {
          ...CustomFields
        }
      }
      childrenConfiguration {
        visible
        childType
        pluralName
        singularName
        customFields {
          ...CustomFields
        }
      }
      deviceConfiguration {
        customFields {
          ...CustomFields
        }
        measurementTypes {
          id
          title
        }
      }
      maintenanceConfiguration {
        interruptedServices {
          roleId
          id
          title
        }
        emails {
          id
          title
          header
          triggerFrom
          triggerTo
          recipientsTo
          recipientsCc
          text
          repeatPeriodTime {
            enabled
            unit
            value
          }
          reminderBeforeDisconnect {
            enabled
            hours
          }
        }
      }
      antennasConfiguration {
        visible
      }
    }
  }
`;

export const GET_PROJECTS_BY_COMPANY = gql`
  query GetProjectsByCompany($refName: String!) {
    mdmProjectsByCompany(companyReference: $refName) {
      id
      title
      createdAt
    }
  }
`;

export const GET_PROJECT = gql`
  ${CORE_PROJECT_FIELDS}
  query GetProject($id: String!) {
    mdmProjectById(id: $id) {
      ...CoreProjectFields
    }
  }
`;

export const CREATE_PROJECT = gql`
  ${CORE_PROJECT_FIELDS}
  mutation CreateProject($project: MdmProjectInputInput!) {
    createMdmProject(input: $project) {
      ...CoreProjectFields
    }
  }
`;

export const UPDATE_PROJECT = gql`
  ${CORE_PROJECT_FIELDS}
  mutation UpdateProject($project: MdmProjectDTOInput!) {
    updateMdmProject(input: $project) {
      ...CoreProjectFields
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: String!) {
    deleteMdmProject(id: $id) {
      id
      title
    }
  }
`;

export const CREATE_UPDATE_DEVICE_CONFIGURATION = gql`
  mutation CreateUpdateDeviceConfiguration($input: MdmDeviceConfigDTOInput!) {
    createUpdateDeviceConfig(input: $input) {
      id
      title
      measurementMappings {
        key
        value
      }
      vitalityThreshold
    }
  }
`;

export const DELETE_DEVICE_CONFIGURATION = gql`
  mutation DeleteDeviceConfiguration($id: String!) {
    deleteDeviceConfig(configId: $id) {
      id
    }
  }
`;
